







































































































































































































































import Vue from "vue";
import PublishmentPreview from "@/components/Form/PublishmentPreview.vue";
import AdvertisementPreview from "@/components/Form/AdvertisementPreview.vue";
import { Advertisement } from "@/interfaces/advertisement";
import { PublishmentOrder } from "@/interfaces/publishmentorder";
import { HeaderProcess } from "@/plugins/HeaderProcess";
export default Vue.extend({
  components: { PublishmentPreview, AdvertisementPreview },
  data() {
    return {
      errors: {},
      advertisementExpanded: false,
      isLoading: false,
      phase: "input",
      advertisement: {} as Advertisement,
      publishment: {} as PublishmentOrder,
      cardStatus: "initial",
      bankStatus: "initial",
      paymentMode: null,
      cardHolderEmail: "",
      cardHolderHomePhoneNumber: "",
    };
  },
  mounted() {
    (async () => {
      this.advertisement = await this.$store.dispatch("get", [
        "/api/adv/posts/" + this.$route.params.id
      ]);
      if (this.advertisement.publishmentOrder) {
        this.publishment = await this.$store.dispatch("get", [
          this.advertisement.publishmentOrder["@id"]
        ]);
      }
    })();
  },
  methods: {
    async startPayment(use3ds: boolean) {
      this.cardStatus = "proceeding";
      window.pop.show();
      const paymentKey = await this.issuePaymentKey(use3ds);
      if (!("" + paymentKey).length) {
        setTimeout(() => {
          window.pop.hide();
          this.cardStatus = "failure";
        }, 5000);
        return;
      }
      window.pop.pay(paymentKey, {
        onSuccess: () => {
          this.cardStatus = "success";
        },
        onFailure: () => {
          this.cardStatus = "failure";
        },
        onIncomplete: () => {
          this.cardStatus = "incomplete";
        }
      });
    },
    async issuePaymentKey(use3ds: boolean) {
      if (this.publishment.id) {
        if (use3ds) {
          return await this.$store.dispatch("post", [
            "/api/adv/issue_payment_key/" + this.publishment.id,
            {
              card: 1,
              cardHolderEmail: this.cardHolderEmail,
              cardHolderHomePhoneNumber: this.cardHolderHomePhoneNumber,
            },
          ]);
        } else {
          return await this.$store.dispatch("post", [
            "/api/adv/issue_payment_key/" + this.publishment.id,
          ]);
        }
      }
    },
    async bankTransfer() {
      if (this.publishment.id) {
        await this.$store.dispatch("post", [
          this.publishment["@id"] + "/payment/bank_transfer"
        ]);
        this.bankStatus = "success";
      }
    }
  },
  computed: {
    headerProcess() {
      const hp = new HeaderProcess();
      hp.processes.push({ idx: 1, title: "広告新規作成" });
      hp.processes.push({ idx: 2, title: "広告新規作成確認画面" });
      hp.processes.push({ idx: 3, title: "広告掲載申し込み" });
      hp.processes.push({ idx: 4, title: "広告掲載申し込み確認画面" });
      hp.processes.push({ idx: 5, title: "広告掲載申し込み完了" });

      hp.activeIdx = 5;

      return hp;
    },
    isPage() {
      return true;
    }
  }
});
